import keycode from 'keycode';
import { detectKeyboardFocus, focusKeyPressed, listenForFocusKeys, } from './keyboardFocus';
/**
 * 产生KeyboardFocus相关事件的事件包装器
 */
var KeyboardFocusWrapper = /** @class */ (function () {
    /**
     * Creates an instance of KeyboardFocusWrapper.
     * @param {HTMLElement} element 产生事件的HTML元素
     * @param {KeyboardFocusEventListeners} eventListeners 事件监听器
     */
    function KeyboardFocusWrapper(element, eventListeners) {
        var _this = this;
        this.element = element;
        this.eventListeners = eventListeners;
        this.keyboardFocusCheckTime = 50;
        this.keyboardFocusMaxCheckTimes = 5;
        listenForFocusKeys();
        this.onKeyboardFocus = this.onKeyboardFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.eventTriggers = [
            {
                name: 'focus',
                callback: this.onFocus.bind(this),
            },
            {
                name: 'mousedown',
                callback: this.onBlur,
            },
            {
                name: 'touchstart',
                callback: this.onBlur,
            },
            {
                name: 'blur',
                callback: this.onBlur,
            },
            {
                name: 'keydown',
                callback: this.onKeyDown.bind(this),
            },
            {
                name: 'keyup',
                callback: this.onKeyUp,
            },
        ];
        this.eventTriggers.forEach(function (_a) {
            var name = _a.name, callback = _a.callback;
            return _this.element.addEventListener(name, callback, false);
        });
    }
    KeyboardFocusWrapper.prototype.clean = function () {
        var _this = this;
        this.eventTriggers.forEach(function (_a) {
            var name = _a.name, callback = _a.callback;
            _this.element.removeEventListener(name, callback, false);
        });
    };
    KeyboardFocusWrapper.prototype.onFocus = function (event) {
        detectKeyboardFocus(this, this.element, this.onKeyboardFocus);
    };
    KeyboardFocusWrapper.prototype.onKeyboardFocus = function () {
        this.keyDown = false;
        this.keyboardFocused = true;
        this.eventListeners.onFocus();
    };
    KeyboardFocusWrapper.prototype.onBlur = function () {
        clearTimeout(this.keyboardFocusTimeout);
        focusKeyPressed(false);
        if (this.keyboardFocused) {
            this.keyboardFocused = false;
            this.eventListeners.onBlur();
        }
    };
    KeyboardFocusWrapper.prototype.onKeyDown = function (event) {
        var key = keycode(event);
        if (!this.keyDown && this.keyboardFocused && key === 'space') {
            this.keyDown = true;
            this.eventListeners.onSpaceDown(event);
        }
    };
    KeyboardFocusWrapper.prototype.onKeyUp = function (event) {
        var key = keycode(event);
        if (this.keyboardFocused && key === 'space') {
            this.keyDown = false;
            this.eventListeners.onSpaceUp(event);
        }
    };
    return KeyboardFocusWrapper;
}());
export default KeyboardFocusWrapper;
//# sourceMappingURL=KeyboardFocusWrapper.js.map